import { useApolloClient, useMutation } from '@apollo/client'
import { ReactElement, useEffect } from 'react'
import { useIntl, defineMessages } from 'react-intl'
import { useNavigate } from 'react-router-dom'

import FormLayoutV2 from 'components/v2/FormLayout'
import { withLastUrl } from 'features/App/components/WithLastUrl'
import { IBusinessCustomerFormValues } from 'features/BusinessCustomer/types'
import { NewBusinessCustomer } from 'features/BusinessCustomer/components/NewBusinessCustomerForm'
import { CREATE_BUSINESS_CUSTOMER } from 'features/BusinessCustomer/mutations-legacy'
import { BusinessCustomerFormUtils } from 'features/BusinessCustomer/utils'
import { GET_BUSINESS_CUSTOMERS_LIST } from 'features/BusinessCustomer/queries-legacy'
import { EUrls } from 'utils/urls'

const messages = defineMessages({
  helmet: {
    id: 'businessCustomer.new.helmet',
    defaultMessage: 'Add Business Customer'
  }
})

const NewBusinessCustomerView = (): ReactElement => {
  const intl = useIntl()
  const navigate = useNavigate()
  const client = useApolloClient()
  const [createBusinessCustomer, { error, loading }] = useMutation(CREATE_BUSINESS_CUSTOMER, {
    onCompleted: async (): Promise<void> => {
      await client.refetchQueries({ include: [GET_BUSINESS_CUSTOMERS_LIST] })
      navigate(EUrls.BUSINESS_CUSTOMERS)
    },
    onError: (): void => {
      // Do nothing
    }
  })

  const handleSubmit = (formValues: IBusinessCustomerFormValues): void => {
    createBusinessCustomer({
      variables: {
        input: BusinessCustomerFormUtils.mapFormToMutation(formValues)
      }
    })
  }

  useEffect((): void => {
    document.title = intl.formatMessage(messages.helmet)
  }, [])

  return (
    <FormLayoutV2.Container>
      <NewBusinessCustomer onSubmit={handleSubmit} loading={loading} error={error} isShowingKreditSettings />
    </FormLayoutV2.Container>
  )
}

export default withLastUrl(NewBusinessCustomerView)
